export const getValueByPath = ({
  object,
  path,
}: {
  object: Record<string, unknown>;
  path?: string;
}): unknown | undefined => {
  if (!path) {
    return;
  }
  let iterator: Record<string, unknown> = object;
  for (let i = 0; i < path.split(".").length; i++) {
    const subPath = path.split(".")[i];
    const value = iterator[subPath];
    if (value !== undefined) {
      iterator = value as Record<string, unknown>;
    } else {
      return undefined;
    }
  }
  return iterator;
};
